export var ExperimentModalType;
(function (ExperimentModalType) {
    ExperimentModalType["OwnerProjectDelete"] = "OwnerProjectDelete";
    ExperimentModalType["OwnerProjectRestore"] = "OwnerProjectRestore";
    ExperimentModalType["LeaveSharedProject"] = "LeaveSharedProject";
    ExperimentModalType["UnableLeaveSharedProject"] = "UnableLeaveSharedProject";
})(ExperimentModalType || (ExperimentModalType = {}));
